import { ROUTES } from 'constants/routes';
import { useHistory } from 'react-router-dom';
import { pushAnalyticsEvent } from 'helpers/analytics';
import { StyledPaper, StyledText, StyledPoints, StyledButton } from './BalanceCard.styles';

interface BalanceCardProps {
  className?: string;
  points: number;
  pageTitle: string;
}

const BalanceCard = ({ points = 0, className, pageTitle }: BalanceCardProps) => {
  const history = useHistory();

  const handleOnClick = () => {
    pushAnalyticsEvent({ event: 'ZsActivity', location: pageTitle });
    history.push(ROUTES.ZS_ACTIVITY);
  };

  return (
    <StyledPaper aria-label="Points Total" className={className}>
      <StyledButton onClick={handleOnClick}>
        <StyledText variant="h6">Your Z Balance</StyledText>
        <StyledPoints points={points} />
      </StyledButton>
    </StyledPaper>
  );
};

export default BalanceCard;
